import { useLocation } from "react-router-dom"
import { SEO } from "./Seo"
import { DEFAULT_SEO_DESCRIPTION } from "./seoConfig"
import { isRestaurantPublicTrackingPath } from "../analytics/trackingRoutes"

const publicPathPatterns = [
  /^\/$/,
  /^\/como-funciona$/,
  /^\/restaurantes$/,
  /^\/cardapio-digital-publico$/,
  /^\/cardapio-pronto-gratis$/,
  /^\/quiz(\/[a-z0-9-]+)?$/,
  /^\/courier$/,
  /^\/seja-um-revendedor$/,
  /^\/terms-of-service$/,
  /^\/privacy-policy$/,
  /^\/refund-policy$/,
  /^\/cancellation-policy$/,
]

export const SeoRouteGuard = () => {
  const { pathname } = useLocation()

  const isMarketingRoute = publicPathPatterns.some((pattern) => pattern.test(pathname))
 
  const isRestaurantPublicMenu = isRestaurantPublicTrackingPath(pathname)
 
  const isPublicPath = isMarketingRoute || isRestaurantPublicMenu

  return (
    <SEO
      title="Mestre da Comanda | Sistema para restaurante"
      description={DEFAULT_SEO_DESCRIPTION}
      path={pathname}
      noindex={!isPublicPath}
    />
  )
}
